module.exports = __webpack_public_path__ + "static/media/caros-regular.fcdae128.woff";